import React from 'react';
import { Users, UserPlus, Trash2 } from 'lucide-react';
import { formatDate } from './vaultUtils';

export function ExecutorsTab({ executors, onAddClick, onRemove }) {
  return (
    <div className="space-y-4">
      <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 flex items-start gap-3">
        <Users className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" />
        <div className="text-sm">
          <p className="font-medium text-amber-800">Estate Executors</p>
          <p className="text-amber-700">
            Executors can view and download documents marked as "Executors Only". They cannot edit or delete documents.
          </p>
        </div>
      </div>

      <div className="flex justify-between items-center">
        <h3 className="font-semibold text-gray-900">Designated Executors</h3>
        <button onClick={onAddClick} className="flex items-center gap-2 px-3 py-1.5 bg-teal-600 text-white text-sm rounded-lg hover:bg-teal-700 transition-colors" data-testid="add-executor-btn">
          <UserPlus className="w-4 h-4" />Add Executor
        </button>
      </div>

      {executors.length === 0 ? (
        <div className="text-center py-8 bg-gray-50 rounded-lg border border-gray-200">
          <Users className="w-10 h-10 text-gray-400 mx-auto mb-3" />
          <p className="text-gray-600 mb-2">No executors designated yet</p>
          <p className="text-sm text-gray-500">Add family members who should have access to restricted documents</p>
        </div>
      ) : (
        <div className="space-y-2">
          {executors.map((exec) => (
            <div key={exec.executor_id} className="flex items-center justify-between p-3 bg-white rounded-lg border border-gray-200" data-testid={`executor-${exec.executor_id}`}>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-amber-100 rounded-full flex items-center justify-center">
                  <Users className="w-5 h-5 text-amber-600" />
                </div>
                <div>
                  <p className="font-medium text-gray-900">{exec.name || exec.executor_name}</p>
                  <p className="text-xs text-gray-500">Added {formatDate(exec.assigned_at)}</p>
                </div>
              </div>
              <button onClick={() => onRemove(exec.executor_id)} className="flex items-center gap-1 px-2 sm:px-3 py-2 text-xs sm:text-sm text-red-500 hover:bg-red-50 rounded-lg transition-colors" title="Remove executor" data-testid={`remove-executor-${exec.executor_id}`}>
                <Trash2 className="w-4 h-4" />
                <span className="sm:hidden">Remove</span>
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
